import React from "react";
import {
  FaEnvelope,
  FaPhoneAlt,
  FaLinkedinIn,
} from "react-icons/fa";

import "./StaffPageJana.css";

import principalImage from "./peincipal.jpg";
import vicePrincipalImage from "./mrsamuel.jpg";
import deanImage from "./dean.jpg";



const schoolLeadershipTeam = [

  {
    image: principalImage,
    name: "Mrs. Cecelia Freeman",
    role: "Principal",

    description:
      "Dedicated to providing visionary leadership, academic excellence, and a supportive learning environment where every student can succeed.",

    email:
      "principal@messiahmission.edu",

    phone:
      "+231 XXX XXX XXX",

  },


  {
    image: vicePrincipalImage,
    name: "Mr. Samuel T. Gbondo",
    role: "Vice Principal",

    description:
      "Committed to strengthening academic programs, supporting teachers, and ensuring every learner receives quality guidance.",

    email:
      "bondosamuel97@gmail.com",

    phone:
      "+231 XXX XXX XXX",

  },


  {
    image: deanImage,
    name: "Mr. Andrew P. Makor",
    role: "Dean of Students",

    description:
      "Focused on student welfare, discipline, leadership development, and creating a positive school culture.",

    email:
      "andrewmakor6@gmail.com",

    phone:
      "+231 XXX XXX XXX",

  },

];





const StaffPage = () => {


  return (

    <section className="school-staff-section">


      <div className="school-staff-header">


        <span className="school-staff-badge">

          School Leadership

        </span>



        <h2 className="school-staff-title">

          Meet Our Dedicated

          <span>
            Administrative Team
          </span>

        </h2>



        <p className="school-staff-description">

          Our leadership team is committed to providing
          excellence in education, maintaining strong
          values, and creating an environment where
          students can grow academically and personally.

        </p>


      </div>





      <div className="school-staff-container">


        {
          schoolLeadershipTeam.map((leader, index) => (


            <div
              className="school-staff-card"
              key={index}
            >



              <div className="school-staff-image-wrapper">


                <img
                  src={leader.image}
                  alt={leader.role}
                  className="school-staff-image"
                />


                <div className="school-staff-role-badge">

                  {leader.role}

                </div>


              </div>





              <div className="school-staff-content">


                <h3 className="school-staff-name">

                  {leader.name}

                </h3>



                <p className="school-staff-position">

                  {leader.role}

                </p>



                <p className="school-staff-text">

                  {leader.description}

                </p>




                <div className="school-staff-contact">


                  <a
                    href={`mailto:${leader.email}`}
                    aria-label={`Email ${leader.name}`}
                  >

                    <FaEnvelope />

                  </a>



                  <a
                    href={`tel:${leader.phone}`}
                    aria-label={`Call ${leader.name}`}
                  >

                    <FaPhoneAlt />

                  </a>



                  <a
                    href="#"
                    aria-label={`${leader.name} LinkedIn`}
                  >

                    <FaLinkedinIn />

                  </a>



                </div>



              </div>



            </div>


          ))
        }


      </div>



    </section>

  );

};


export default StaffPage;


// Salvation In Christ School

// import React from "react";
// import {
//   FaEnvelope,
//   FaPhoneAlt,
//   FaLinkedinIn,
// } from "react-icons/fa";

// import "./Styles/StaffPage.css";

// import principalImage from "./staff.jpg";
// import vicePrincipalImage from "./staff.jpg";
// import deanImage from "./staff.jpg";



// const schoolLeadershipTeam = [

//   {
//     image: principalImage,
//     name: "Dr. John Doe",
//     role: "Principal",

//     description:
//       "Dedicated to providing visionary leadership, academic excellence, and a supportive learning environment where every student can succeed.",

//     email:
//       "principal@messiahmission.edu",

//     phone:
//       "+231 XXX XXX XXX",

//   },


//   {
//     image: vicePrincipalImage,
//     name: "Mrs. Jane Doe",
//     role: "Vice Principal",

//     description:
//       "Committed to strengthening academic programs, supporting teachers, and ensuring every learner receives quality guidance.",

//     email:
//       "viceprincipal@messiahmission.edu",

//     phone:
//       "+231 XXX XXX XXX",

//   },


//   {
//     image: deanImage,
//     name: "Mr. Chris Sati",
//     role: "Dean of Students",

//     description:
//       "Focused on student welfare, discipline, leadership development, and creating a positive school culture.",

//     email:
//       "dean@messiahmission.edu",

//     phone:
//       "+231 XXX XXX XXX",

//   },

// ];





// const StaffPage = () => {


//   return (

//     <section className="school-staff-section">


//       <div className="school-staff-header">


//         <span className="school-staff-badge">

//           School Leadership

//         </span>



//         <h2 className="school-staff-title">

//           Meet Our Dedicated

//           <span>
//             Administrative Team
//           </span>

//         </h2>



//         <p className="school-staff-description">

//           Our leadership team is committed to providing
//           excellence in education, maintaining strong
//           values, and creating an environment where
//           students can grow academically and personally.

//         </p>


//       </div>





//       <div className="school-staff-container">


//         {
//           schoolLeadershipTeam.map((leader, index) => (


//             <div
//               className="school-staff-card"
//               key={index}
//             >



//               <div className="school-staff-image-wrapper">


//                 <img
//                   src={leader.image}
//                   alt={leader.role}
//                   className="school-staff-image"
//                 />


//                 <div className="school-staff-role-badge">

//                   {leader.role}

//                 </div>


//               </div>





//               <div className="school-staff-content">


//                 <h3 className="school-staff-name">

//                   {leader.name}

//                 </h3>



//                 <p className="school-staff-position">

//                   {leader.role}

//                 </p>



//                 <p className="school-staff-text">

//                   {leader.description}

//                 </p>




//                 <div className="school-staff-contact">


//                   <a
//                     href={`mailto:${leader.email}`}
//                     aria-label={`Email ${leader.name}`}
//                   >

//                     <FaEnvelope />

//                   </a>



//                   <a
//                     href={`tel:${leader.phone}`}
//                     aria-label={`Call ${leader.name}`}
//                   >

//                     <FaPhoneAlt />

//                   </a>



//                   <a
//                     href="#"
//                     aria-label={`${leader.name} LinkedIn`}
//                   >

//                     <FaLinkedinIn />

//                   </a>



//                 </div>



//               </div>



//             </div>


//           ))
//         }


//       </div>



//     </section>

//   );

// };


// export default StaffPage;